import ViewObjective from "./ViewObjective";
import ViewStep from "./ViewStep";

const View = ({ incident }) => {
  const hasObjectives = incident?.objectives?.length > 0;

  return (
    <>
      <div className="col-12 col-md-8 mb-4">
        <div
          className="border rounded p-2 h-100 d-flex flex-column scroll-no-buttons"
          style={{
            minHeight: "80vh",
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="mb-2">
            <strong>Incident Title:</strong> {incident.incidentTitle}
          </div>

          <div className="mb-2">
            <strong>Story Board:</strong>
            <div>{incident.storyBoard}</div>
          </div>

          <div className="mb-2">
            <strong>Task:</strong>
            <div>{incident.task}</div>
          </div>

          <div>
            <strong>Solution:</strong>
            <div>
              {incident.steps?.map((step, i) => (
                <ViewStep
                  key={step.id || step.description || i}
                  step={step.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-2 mb-4">
        <div
          className="border rounded p-2 h-100 scroll-no-buttons"
          style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}
        >
          {hasObjectives &&
            incident.objectives.map((objective) => (
              <ViewObjective
                key={objective.id || objective.objectiveName}
                objective={objective}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default View;
